import { proxyCustomElement, HTMLElement, createEvent, h } from '@stencil/core/internal/client';
import { S as Sortable } from './sortable.esm.js';
import { a as mapRange } from './utils.js';
import { a as extractElementsFromSlot } from './slot-utils.js';
import { d as defineCustomElement$4 } from './action-card.js';
import { d as defineCustomElement$3 } from './auto-grid.js';
import { d as defineCustomElement$2 } from './icon.js';

const videoSorterCss = ".picker-enclosure.active ::slotted(tt-video-card){cursor:grab;user-select:none}.picker-enclosure.active ::slotted(tt-video-card.tt-video-sorter-sortable-ghost-hidden){opacity:0}";

const VideoSorter = /*@__PURE__*/ proxyCustomElement(class extends HTMLElement {
  constructor() {
    super();
    this.__registerHost();
    this.__attachShadow();
    this.ttOrderChange = createEvent(this, "tt-change", 7);
    this.sorting = false;
    this.placeholderVideoSlots = 0;
    this.active = true;
    this.order = '';
    this.stickyDrag = true;
    this.removeOnSpill = false;
  }
  connectedCallback() {
    this.handleActiveChange = this.handleActiveChange.bind(this);
    this.handleSlotChange = this.handleSlotChange.bind(this);
    this.handleSorting = this.handleSorting.bind(this);
    this.updateDragMode = this.updateDragMode.bind(this);
    this.updateSpillMode = this.updateSpillMode.bind(this);
    // this.handleOrderChange = this.handleOrderChange.bind(this)
    this.sortable = Sortable.create(this.element, {
      disabled: !this.active,
      animation: 250,
      delay: 0,
      filter: 'tt-action-card',
      draggable: 'tt-video-card',
      dataIdAttr: 'video-id',
      chosenClass: 'tt-video-sorter-sortable-chosen',
      ghostClass: 'tt-video-sorter-sortable-ghost',
      dragClass: 'tt-video-sorter-sortable-drag',
      direction: 'horizontal',
      onStart: () => {
        this.sorting = true;
      },
      onEnd: this.handleSorting,
      // remove on spill
      removeOnSpill: this.removeOnSpill,
      onSpill: this.handleSorting,
    });
    this.updateDragMode();
  }
  handleActiveChange() {
    this.sortable.option('disabled', !this.active);
  }
  updateDragMode() {
    this.sortable.option('ghostClass', `tt-video-sorter-sortable-ghost${this.stickyDrag ? '-hidden' : ''}`);
    this.sortable.option('dragClass', `tt-video-sorter-sortable-drag${!this.stickyDrag ? '-hidden' : ''}`);
  }
  updateSpillMode() {
    this.sortable.option('removeOnSpill', this.removeOnSpill);
  }
  handleSlotChange(event) {
    var _a, _b;
    const videoCards = extractElementsFromSlot(event.target, 'tt-video-card');
    const vcOrder = videoCards.map((videoCard) => videoCard.videoId);
    if (this.sorting) {
      return;
    }
    if (((_a = this.sortable) === null || _a === void 0 ? void 0 : _a.toArray().length) === 0) {
      (_b = this.sortable) === null || _b === void 0 ? void 0 : _b.sort(vcOrder, false);
    }
  }
  handleSorting(_e) {
    var _a;
    this.order = (_a = this.sortable) === null || _a === void 0 ? void 0 : _a.toArray().join(',');
    this.ttOrderChange.emit({ order: this.order });
    this.sorting = false;
  }
  render() {
    return (h("div", { class: { 'picker-enclosure': true, 'active': this.active } }, h("tt-auto-grid", { "grid-gap": "16px", "min-item-width": "225px" }, h("slot", { onSlotchange: this.handleSlotChange }), mapRange(this.placeholderVideoSlots, (i) => (h("tt-action-card", { label: `placeholder ${i}` }))))));
  }
  get element() { return this; }
  static get watchers() { return {
    "active": ["handleActiveChange"],
    "stickyDrag": ["updateDragMode"],
    "removeOnSpill": ["updateSpillMode"]
  }; }
  static get style() { return videoSorterCss; }
}, [1, "tt-video-sorter", {
    "active": [4],
    "order": [1],
    "stickyDrag": [4, "sticky-drag"],
    "removeOnSpill": [4, "remove-on-spill"],
    "placeholderVideoSlots": [32]
  }]);
function defineCustomElement$1() {
  if (typeof customElements === "undefined") {
    return;
  }
  const components = ["tt-video-sorter", "tt-action-card", "tt-auto-grid", "tt-icon"];
  components.forEach(tagName => { switch (tagName) {
    case "tt-video-sorter":
      if (!customElements.get(tagName)) {
        customElements.define(tagName, VideoSorter);
      }
      break;
    case "tt-action-card":
      if (!customElements.get(tagName)) {
        defineCustomElement$4();
      }
      break;
    case "tt-auto-grid":
      if (!customElements.get(tagName)) {
        defineCustomElement$3();
      }
      break;
    case "tt-icon":
      if (!customElements.get(tagName)) {
        defineCustomElement$2();
      }
      break;
  } });
}

const TtVideoSorter = VideoSorter;
const defineCustomElement = defineCustomElement$1;

export { TtVideoSorter, defineCustomElement };
